import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
export function GrowthRoadmap() {
  const phases = [{
    time: '0–3 Months',
    title: 'Foundation & Launch',
    metrics: ['Platform launch', '100 practitioners', '250 users']
  }, {
    time: '3–6 Months',
    title: 'Initial Scale',
    metrics: ['500+ paying users', '15+ enterprise clients', '$20K MRR']
  }, {
    time: '6–12 Months',
    title: 'Ecosystem Expansion',
    metrics: ['2,500+ paying users', '50+ enterprise clients', '1,000 practitioners', '$50K MRR']
  }];
  return <Section background="ivory" data-id="element-193" data-mp="y0agteaql3o0">
      <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-194" data-mp="12stxik4q0ex1">
        <FadeIn data-id="element-195" data-mp="12uet8d2ru3wh">
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-6" data-id="element-196" data-mp="12uwrtgcwou7k">
            Scaling With Intentional Precision
          </h2>
        </FadeIn>
      </div>

      <div className="relative max-w-4xl mx-auto" data-id="element-197" data-mp="ab832hj83uys">
        {/* Vertical Line */}
        <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-[1px] bg-purple-300 md:-translate-x-1/2" data-id="element-198" data-mp="38a5oywevtvqo"></div>

        <div className="space-y-16" data-id="element-199" data-mp="33cw0bizbho3w">
          {phases.map((phase, idx) => <FadeIn key={idx} delay={idx * 200} data-id="element-200" data-mp="2ykm81waqcbyg" data-mpi={idx}>
              <div className={`relative flex flex-col md:flex-row items-start ${idx % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-201" data-mp="2tmkn15tqu2kc">
                {/* Timeline Node */}
                <div className="absolute left-4 md:left-1/2 w-3 h-3 bg-purple-600 rounded-full -translate-x-[5px] md:-translate-x-1/2 mt-2 ring-4 ring-ivory" data-id="element-202" data-mp="2pimq91rw53ug"></div>

                {/* Content */}
                <div className={`ml-12 md:ml-0 md:w-1/2 ${idx % 2 === 0 ? 'md:pl-16' : 'md:pr-16 md:text-right'}`} data-id="element-203" data-mp="2fomkcxosbuko">
                  <div className="text-sm uppercase tracking-widest text-purple-700 font-semibold mb-2" data-id="element-204" data-mp="dudhikayyy06">
                    {phase.time}
                  </div>
                  <h3 className="text-2xl font-serif text-charcoal mb-4" data-id="element-205" data-mp="23cu0igcw1gv1">
                    {phase.title}
                  </h3>
                  <ul className={`space-y-2 text-charcoal/70 ${idx % 2 !== 0 ? 'md:flex md:flex-col md:items-end' : ''}`} data-id="element-206" data-mp="284bziyvcp7dd">
                    {phase.metrics.map((metric, mIdx) => <li key={mIdx} className="flex items-center" data-id="element-207" data-mp="1ye0nep1ijrve" data-mpi={mIdx}>
                        <span className={`w-1.5 h-1.5 rounded-full bg-purple-400 mr-2 ${idx % 2 !== 0 ? 'md:ml-2 md:mr-0 md:order-last' : ''}`} data-id="element-208" data-mp="2m2s34gxx2hra"></span>
                        {metric}
                      </li>)}
                  </ul>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </Section>;
}